// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteApiKeyRequestModel from '../../model/delete-api-key-request-model';
import DeleteApiKeyRequestDTO from '../dto/delete-api-key-request-dto';
import dtoSchema from '../schemas/delete-api-key-request-schema';

export default abstract class DeleteApiKeyRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteApiKeyRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteApiKeyRequestDTO>): DeleteApiKeyRequestModel;
  static toModel(dto: DeepPartial<DeleteApiKeyRequestDTO> | undefined | null): DeleteApiKeyRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteApiKeyRequestDTO> | undefined | null): DeleteApiKeyRequestModel | undefined {
    return dto ? new DeleteApiKeyRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteApiKeyRequestModel> | DeleteApiKeyRequestModel): DeleteApiKeyRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteApiKeyRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteApiKeyRequestModel, can not map to DeleteApiKeyRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
